





import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import "./main.css"
import { MouseHoverContext } from './mousHoverContext';
import Projects from './projects';
import { Route, Routes, useLocation, useNavigate,Navigate  } from 'react-router-dom';
import Home from './home.jsx';
import { SnackbarProvider, useSnackbar } from "notistack";

import { visitedContext } from './visitedContext.js';
import OneProject from './oneProject.jsx';
import Aboute from './aboute.jsx';
import { motion } from "framer-motion";
import { gsap } from "gsap";
import NotFound from './notFound.jsx';
import Contact from './contact.jsx';
import { ColoredContext } from './color.js';


function Main() {
    const [percentage, setPercentage] = useState(0);
    const [loadClass, setLoadClass] = useState("load");
    const [decorClass, setDecorClass] = useState("decor");
    const [containerClass, setContainerClass] = useState("container");
    const[hoverElement,setHoverElement]=useState(0)
    const[backgroundPosition,setBackgroundPosition]=useState(0)
    const [snap, setSnap] = useState(false);
    const navigate = useNavigate(); // Hook to handle navigation
    const {mousehover, setMouseHover}= useContext(MouseHoverContext);
    const location = useLocation(); // Detect current route
    const { visitedPage, setVisitedPage } = useContext(visitedContext);
    const[firstVisit,setFirstVisit]=useState(true)
    const { currentColor, setCurrentColor } = useContext(ColoredContext);

    const { enqueueSnackbar } = useSnackbar();


    useEffect(() => {
         if (visitedPage.projects || visitedPage.about || visitedPage.home || visitedPage.contact) {
        setFirstVisit(false)
      }
    }, [visitedPage]);


    useEffect(() => {
        const start = Date.now();
        const duration = 2500; // 2.5 seconds
    
        const easeOutExpo = (t) => 1 - Math.pow(2, -10 * t); // Exponential easing for smooth acceleration
    
        const animate = () => {
          const now = Date.now();
          const elapsed = now - start;
          const progress = Math.min(elapsed / duration, 1); // Progress from 0 to 1 over 2.5 seconds
    
          setPercentage(Math.round(easeOutExpo(progress) * 100));
    
          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };
    
        animate();
      }, []);



      useEffect(() => {
        // Timer for showing the second component
        const firstTimer = setTimeout(() => {
            setLoadClass("load disappear")
        }, 2000); // 3 seconds for first transition
        const secondTimer = setTimeout(() => {
            setDecorClass("decor disappear2")
        }, 2200); // 3 seconds for first transition

        const thirdTimer = setTimeout(() => {
            setContainerClass("container appear")
        }, 3000); // 3 seconds for first transition
    
    
        // Clear timers if the component unmounts
        return () => {
          clearTimeout(firstTimer);
          clearTimeout(secondTimer);
          clearTimeout(thirdTimer);

        };
      }, []);

      
  useEffect(() => {

  }, []);

  // useEffect(() => {
  //   if (!(location.pathname == "/home")) setHomeClassName("underline")
  //     else if (!(location.pathname == "/projects")) setHomeClassName("underline")
  //     else  if (!(location.pathname == "/Aboute")) setHomeClassName("underline")

  // }, [location.pathname ]);

  const goToHome=()=>{
    if (!(location.pathname == "/")){
       navigate('/', { state: { visited: true } })
    }
  }



const handleEmailClick = () => {
    const email = "Amirali.solltani@gmail.com"; // Replace with your email

    navigator.clipboard
      .writeText(email)
      .then(() => {
        // Show Notistack notification
        enqueueSnackbar("Email Copied To Clipboard!", {
          // variant: "default", // Default style
          variant: "success", // Built-in success variant with a tick

          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          autoHideDuration: 3000, // 9 seconds
          ContentProps: {
            className: "custom-snackbar", // Add a custom class for styling
          },
        });
      })
      .catch((err) => {
        // Handle error
        enqueueSnackbar("Failed to copy email. Try again!", {
          variant: "error", // Error variant
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          autoHideDuration: 3000, // 3 seconds
        });
        console.error("Failed to copy email: ", err);
      });
  };
  

  return (
    <Fragment>
      {firstVisit && <Fragment> 
    <div className={loadClass}>
    <div className="logo-percentage-container">

        <span className="percentage">{percentage}%</span>
        <svg className='logo' viewBox="0 0 29 32" fill="white" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.59633 28.6667L0 32L18.6239 22.9333L21.6835 16L1.59633 28.6667Z"/>
  <path d="M1.72936 28.1333L5.58716 25.7333L18.0917 8L14.5 0L1.72936 28.1333Z"/>
  <path d="M22.0826 16.1333L19.0229 23.0667L22.6147 28.2667L29 32L22.0826 16.1333Z"/>
  <path d="M14.5 32L22.6147 28.6667L28.2018 32H14.5Z"/>
</svg>
<span className="percentage">{percentage}%</span>
</div>
        </div>
        <div className={decorClass}></div>
</Fragment>}
        <div className={currentColor.light?"main light" : "main dark"}>
          <div className= {currentColor.light?"container-menu dark" : "container-menu dark"} >
        <div className={currentColor.light?"menu dark" : "menu dark"} >
        <svg 
    className='page-logo' 
    viewBox="0 0 35 40" 
    fill= {currentColor.light?"white" : "white"} 
    xmlns="http://www.w3.org/2000/svg" 
    onClick= {goToHome}
    onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)}
>
  <path d="M1.59633 28.6667L0 32L18.6239 22.9333L21.6835 16L1.59633 28.6667Z"/>
  <path d="M1.72936 28.1333L5.58716 25.7333L18.0917 8L14.5 0L1.72936 28.1333Z"/>
  <path d="M22.0826 16.1333L19.0229 23.0667L22.6147 28.2667L29 32L22.0826 16.1333Z"/>
  <path d="M14.5 32L22.6147 28.6667L28.2018 32H14.5Z"/>
</svg>
<div className={currentColor.light?"items lightColorText " : "items lightColorText"}>
<span     onMouseEnter={() => {
    setMouseHover(true);
    // setHoverElement(true)
  }}
    onMouseLeave={() => {setMouseHover(false);     
      setHoverElement(false)    }} className={location.pathname == "/"? "underline" : ""} onClick={()=>       navigate('/')} >Home</span>
<span   onMouseEnter={() => setMouseHover(true)}  className={location.pathname == "/Projects"? "underline" : ""}
    onMouseLeave={() => setMouseHover(false)}  onClick={()=>       navigate('/Projects')}>Projects</span>
<span   onMouseEnter={() => setMouseHover(true)}  className={location.pathname == "/About"? "underline" : ""}
    onMouseLeave={() => setMouseHover(false)} onClick={()=>       navigate('/About')}>About</span>
<span   onMouseEnter={() => setMouseHover(true)} className={location.pathname == "/Contact"? "underline" : ""}
    onMouseLeave={() => setMouseHover(false)} onClick={()=>       navigate('/Contact')} >Contact</span>

<div className="image-container">
<img     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)} onClick={() => setCurrentColor({ light: !currentColor.light })}  className={!currentColor.light?"moon" : "moon-disappear  moon"}
                   src={require("./pics/night.png")}
                   />
                   <img     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)} onClick={() => setCurrentColor({ light: !currentColor.light })}  className={!currentColor.light?"sun sun-disappear" : "sun"}
                   src={require("./pics/sun.png")}
                   />
                   </div>
{/* <div  className="toggle-container">
      <span className="label">Light</span>
      <div onMouseEnter={() => setMouseHover(true)}  onMouseLeave={() => setMouseHover(false)} className={`toggle-switch ${currentColor.light ? "dark" : "light"}`} onClick={() => setCurrentColor({ light: !currentColor.light })}>
        <div className={`toggle-knob ${!currentColor.light ? "move-right" : "move-left "}`}></div>
      </div>
      <span className="label">Dark</span>
    </div> */}
  

</div>

</div>
</div>

<Routes>
{/* <Route path="/" element={<Navigate to="/home" replace />} /> */}

  {/* <Route 
    path="/" 
    element={
      <Home
        hoverElement={hoverElement} 
        setHoverElement={setHoverElement} 
        snap={snap} 
        setSnap={setSnap}
        setMouseHover={setMouseHover}
        setBackgroundPosition={setBackgroundPosition}
        firstVisit={firstVisit}
      />
    } 
  /> */}

<Route 
    path="/Projects" 
    element={
      <Projects 
        hoverElement={hoverElement} 
        setHoverElement={setHoverElement} 
        snap={snap} 
        setSnap={setSnap}
        setMouseHover={setMouseHover}
        setBackgroundPosition={setBackgroundPosition}
        firstVisit={firstVisit}
      />
    } 
  />




    <Route 
    path="/" 
    element={
      <Home
        hoverElement={hoverElement} 
        setHoverElement={setHoverElement} 
        snap={snap} 
        setSnap={setSnap}
        setMouseHover={setMouseHover}
        setBackgroundPosition={setBackgroundPosition}
        firstVisit={firstVisit}

      />
    } 
  />
  <Route 
    path="/Contact" 
    element={
      <Contact 
        setMouseHover={setMouseHover}
        hoverElement={hoverElement} 
        setHoverElement={setHoverElement} 
        snap={snap} 
        setSnap={setSnap}
        setBackgroundPosition={setBackgroundPosition}
      />
    } 
  />
  
  <Route 
    path="/About" 
    element={
      <Aboute 
        setMouseHover={setMouseHover}
        hoverElement={hoverElement} 
        setHoverElement={setHoverElement} 
        snap={snap} 
        setSnap={setSnap}
        setBackgroundPosition={setBackgroundPosition}
      />
    } 
  />
  
  <Route 
    path="/OneProject/:projectID/:ProductName" 
    element={
      <OneProject 
        setMouseHover={setMouseHover}
        hoverElement={hoverElement} 
        setHoverElement={setHoverElement} 
        snap={snap} 
        setSnap={setSnap}
        setBackgroundPosition={setBackgroundPosition}
      />
    } 
  />
  
  {/* Catch-All Route for 404 Not Found */}
  <Route 
    path="*" 
    element={
      <NotFound 
        setMouseHover={setMouseHover}
        hoverElement={hoverElement} 
        setHoverElement={setHoverElement} 
        snap={snap} 
        setSnap={setSnap}
        setBackgroundPosition={setBackgroundPosition}
      />
    } 
  />
</Routes>



</div>


<div  className={currentColor.light?"footer dark" : "footer light"} >
  <div className="container-footer">
  <div className="container-top">
    <div className="left-footer">
      <div className={currentColor.light?"text lightColorText " : "text darkColorText"}>
      I am passionate about developing innovative solutions and transforming ideas into functional applications. With expertise in full-stack development, I have successfully delivered projects.
      </div>
      <div className="icons-commnunications">
        <div className="gmail-text">
      <img     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)} onClick={handleEmailClick} className='gmail'
                   src={require("./pics/gmail.png")}
                   />
                   {/* <span className="text"> Amirali.solltani@gmail.com</span> */}

        </div>
        <div className="linkedin-text">

                        <img     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)}  onClick={()=>window.open("https://www.linkedin.com/in/amirali-soltani-109aa7208/", "_blank")}
    className='linkedin'
                   src={require("./pics/linkedin-2.png")}
                   />
            {/* <span className="text"> Amirali.solltani@gmail.com</span> */}

</div>
<img     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)} onClick={()=>window.open("https://github.com/AmiraliSoltani", "_blank")} className='github'
                   src={require("./pics/github-1.png")}
                   />
      </div>
    </div>
    {/* <div className="right-footer">

    </div>
<div className="icons">

{currentColor.light &&
  <img     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)} onClick={() => setCurrentColor({ light: !currentColor.light })} className='icon'
                   src={require("./pics/night.png")}
                   />
}

{!currentColor.light &&

<img     onMouseEnter={() => setMouseHover(true)} 
    onMouseLeave={() => setMouseHover(false)} onClick={() => setCurrentColor({ light: !currentColor.light })} className='icon'
                   src={require("./pics/sun.png")}
                   />
}
</div> */}
  </div>
    <div className="bottom-footer">
    <div className={currentColor.light?"tapered-line dark-line " : "tapered-line white-line"}></div>

<div className={currentColor.light?"writer lightColorText " : "writer darkColorText"}>

  <div className="name"> @2025 Amirali Soltani</div>
  <div className="rights"> All rights reserved</div>
</div>
</div>
    </div>
</div>

        </Fragment>
  );
}

export default Main;
